export default __webpack_public_path__ + "static/media/floor-9.93627935.jpg";